import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../components/Button/index';
import { __, getProp } from '../../utilities';
import SectionSeparator from '../../components/SectionSeparator';
import Loader from '../../components/Loader';
import OtherContent from '../../components/OtherContent';
import RegistrationForm from './registrationForm';
import { login } from './actions';
import { userDetailSelector } from './selectors';
import { errorAlert, hideAlert, okAlert, setStep } from '../App/actions';
import { otherContentContentSelector } from '../App/selectors';
import Api from '../../services/api';

const Wrapper = styled.div``;

const GeneralLoginTextWrapper = styled.div`
  padding: 1rem;
`;

const Row = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  position: relative;
  left: 50%;
  padding-top: 1rem;
  transform: translate(-50%);
  @media (max-width: ${rem(800)}) {
    justify-content: flex-start;
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: ${rem(14)};
  line-height: 1.5;
  letter-spacing: ${rem(0.2)};
  color: ${({ theme }) => theme.color.font.secondary};
`;

const EmailBox = styled.input`
  font-size: ${rem(14)};
  width: 100%;
  max-width: ${rem(300)};
  border-radius: ${rem(3)};
  padding: ${rem(12)} ${rem(20)} !important;
  margin: ${rem(8)} auto;
  display: inline-block;
  border: ${rem(1)} solid #ccc !important;
  border-radius: ${rem(4)};
  box-sizing: border-box;
`;

const PasswordBox = styled(EmailBox)``;

const Form = styled.form``;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33.3%;
  flex-basis: 33.3%;
  text-align: center;
  justify-content: center;
  padding: 0 1rem;
  border-left: 1px solid #ccc;
  @media (max-width: ${rem(800)}) {
    margin-bottom: 2rem;
    width: 100%;
    flex-basis: auto;
  }
`;

const RegistrationWrapper = styled.div`
  max-width: ${rem(801)};
  margin: 0 auto;
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      registration: false,
      registrationIsFetching: false,
      loginIsFetching: false,
    };
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitRegistration = this.handleSubmitRegistration.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    if (this.props.user !== null) {
      dispatch(
        setStep('passengers', {
          for: 'reservations',
          info: {},
        }),
      );
    }
  }

  handleChangeEmail(event) {
    this.setState({ email: event.target.value });
  }

  handleChangePassword(event) {
    this.setState({ password: event.target.value });
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;
    if (nextProps.user !== this.props.user && nextProps.user !== null) {
      dispatch(
        setStep('passengers', {
          for: 'reservations',
          info: {},
        }),
      );
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    this.setState({ loginIsFetching: true });
    try {
      await dispatch(login(this.state.email, this.state.password));
      this.setState({ loginIsFetching: false });
    } catch (e) {
      this.setState({ loginIsFetching: false });
    }
  }

  async handleSubmitRegistration(values) {
    const { dispatch } = this.props;
    this.setState({ registrationIsFetching: true });
    try {
      await Api.registration(values);
      try {
        await dispatch(login(values.login, values.password_client));
        dispatch(
          okAlert(
            __('Registrácia úspešná'),
            __('Hneď budete prihlásený'),
            () => {
              this.setState({ registration: false });
              dispatch(hideAlert());
            },
          ),
        );
      } catch (e) {
        dispatch(
          okAlert(__('Registrácia úspešná'), __('Môžete sa prihlásiť'), () => {
            this.setState({ registration: false });
            dispatch(hideAlert());
          }),
        );
      }
      this.setState({ registrationIsFetching: false });
    } catch (e) {
      const errorName = getProp(e, ['details', 'name'], '');
      if (errorName === 'EMAIL_ALREADY_EXISTS') {
        dispatch(errorAlert(__('Tento email už existuje')));
      } else if (errorName === 'LOGIN_ALREADY_EXISTS') {
        dispatch(errorAlert(__('Toto prihlasovacie meno už existuje')));
      } else {
        dispatch(errorAlert(__('Nastala chyba pri registrácii')));
      }
      this.setState({ registrationIsFetching: false });
    }
  }

  render() {
    if (this.state.registration) {
      return (
        <RegistrationWrapper>
          <SectionSeparator content={__('Nová registrácia')} />
          <RegistrationForm
            onClickBack={() => this.setState({ registration: false })}
            onSubmit={this.handleSubmitRegistration}
            isFetching={this.state.registrationIsFetching}
          />
          <br />
          <OtherContent content={this.props.gdprLink} />
          <br />
        </RegistrationWrapper>
      );
    }
    return (
      <Wrapper>
        <Row>
          <Col>
            <SectionSeparator content={__('Prihláste sa')} />
            {this.state.loginIsFetching ? (
              <Loader size="xxl" text={__('Moment prosím')} />
            ) : (
              <React.Fragment>
                <Title>{__('Prihlasovacie meno')}</Title>
                <Form onSubmit={this.handleSubmit}>
                  <EmailBox
                    value={this.state.email}
                    onChange={this.handleChangeEmail}
                  />
                  <Title>{__('Heslo')}</Title>
                  <PasswordBox
                    type="password"
                    value={this.state.password}
                    onChange={this.handleChangePassword}
                  />
                  <br />
                  <Button type="submit" primary name="submit">
                    {__('Prihlásit sa')}
                  </Button>
                  <br />
                  <br />
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${
                      process.env.REACT_APP_API_BASE_URL
                    }/club/registration/lostpassword/`}
                  >
                    <Button type="button">{__('Zabudli ste heslo?')}</Button>
                  </a>
                </Form>
              </React.Fragment>
            )}
          </Col>
          <Col>
            <SectionSeparator content={__('Registrácia')} />
            <OtherContent content={this.props.registerText} />
            <Button
              primary
              onClick={() => {
                this.setState({ registration: true });
              }}
            >
              {__('Registrácia')}
            </Button>
          </Col>
          <Col>
            <SectionSeparator content={__('Bez prihlásenia')} />
            <OtherContent content={this.props.withoutLoginText} />
            <Button
              primary
              onClick={() => {
                const { dispatch } = this.props;
                dispatch(
                  setStep('passengers', {
                    for: 'reservations',
                    info: {},
                  }),
                );
              }}
            >
              {__('Pokračovať bez prihlásenia')}
            </Button>
          </Col>
        </Row>
        <GeneralLoginTextWrapper>
          <OtherContent content={this.props.generalLoginText} />
        </GeneralLoginTextWrapper>
      </Wrapper>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: userDetailSelector(state),
  generalLoginText: otherContentContentSelector('RESERVATION_LOGIN_PAGE')(
    state,
  ),
  gdprLink: otherContentContentSelector('GDPR_LINK')(state),
  registerText: otherContentContentSelector('RESERVATION_REGISTER')(state),
  withoutLoginText: otherContentContentSelector('RESERVATION_WITHOUT_LOGIN')(
    state,
  ),
});

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js